module.exports = __webpack_public_path__ + "img/fineness-2@2x.57923c4.png";